// Import Assets
import profile from '../assets/profile.jpg';

const About = () => {
    return (
        <section className='about'>
            <h2>About Me</h2>
            <p>
            I'm A Final year CSE undergrad at BATU university.
            I have built Full-stack Applications and Currently exploring the world of Blockchain Development, Crypto, Web 3.0, De-Fi and DAO.
            I've a good grasp of Data structures & Algorithms, I practicize on Leetcode(Solved 300+ problems). 
            I am well versed with Computer Science fundamentals like OOPS, Operating Systems, Database Management Systems, Computer Networks and also have keen interest in System Design.
            I enjoy tackling every-day challenges by using technology, with an incessant thirst for knowledge. When presented with opportunities outside of my comfort zone, I take them in stride and strive to excel.
            I'm looking for internship/full-time role in web3 and software engineering domain. 
            </p>
        </section>
    );
}

export default About;